export const NO_AXIS = '__none__';

// The per-slice colors every pie chart was seeded with before Report color
// palettes. Kept only to recognise a pie still holding the seed, which then
// follows its Report's palette (see the pie chart's migration).
export const PASTEL_PALETTE = [
  '#6ea8ff', // blue
  '#9d8df0', // purple
  '#f29bd4', // pink
  '#ff8c8c', // salmon
  '#ffb066', // orange
  '#f5d65b', // yellow
  '#86dd9b', // green
  '#5fd4e3', // cyan
  '#aab4c4', // slate (Other)
];

export const TICK_STYLE = { fontSize: 11, fill: '#78716c' }; // stone-500
export const GRID_STROKE = '#e7e5e4'; // stone-200
export const AXIS_LINE = { stroke: '#d6d3d1' }; // stone-300
export const TICK_LINE = { stroke: '#d6d3d1' }; // stone-300
